// extracted by mini-css-extract-plugin
module.exports = {"PolicyTemplate":"PolicyTemplate___ajktF","header":"header___3Uqxw","navs":"navs___2N07t","content":"content___2npnV"};